import { Container } from "pixi.js";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../ResourceManager/ResourceManager";
import * as PIXI from "pixi.js";
import { JSONResource } from "../ResourceManager/JSONResource";
import { AtlasResource } from "../ResourceManager/AtlasResource";
import { JackpotDisplayType, Settings } from "../Settings";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { ISkeletonData, ITrackEntry, Spine } from "pixi-spine";
import { CreateSpineResources, Point, Safe, Scale } from "../MyHelpers";
import { BetConfig, SlotGameBet } from "../api";
import { AudioManager, ITrack, Track } from "../AudioManager";
import { GetOrientation, Orientation } from "../FitScreen";
import { TriggerHintState } from "../../singlegame/singlegame_api";
import { assertTrue } from "../debug";


interface BonusMultiplierLevelSaved {
    bonusMultiplier: number;
    totalBet: number,
}

export class BonusMultiplier {
    protected availableLevelMultiplierPerBet: BonusMultiplierLevelSaved[] = [];
    protected currentLevelPerBet: BonusMultiplierLevelSaved;    
    protected allLevelAnimationGrouped:
        {
            level: number;
            //bonusMultiplierShow: { animName: string[]; loopAnim: boolean; };
            bonusMultiplierLoop: { animName: string[]; loopAnim: boolean; };
        }[];

    protected audio : AudioManager = null;
    protected resid : ResourceIdentifier = null;

    protected levels: number[] = [1, 2, 3]

    constructor(enabledBets: BetConfig[] , audio : AudioManager , resid : ResourceIdentifier, triggerHintStates: TriggerHintState[] = null) {
        
        //init bet levels and particles 
        enabledBets?.forEach((b) => {
            // let randomIndex = 1;

            let multiplier = triggerHintStates?.find(t => t.Bet.InCents == b.Bet.TotalBetCents.InCents)?.Multiplier ?? 1

            assertTrue(this.levels.includes(multiplier), `Multiplier ${multiplier} is not valid, valid multipliers are ${this.levels.join(", ")}`);


            this.availableLevelMultiplierPerBet.push({
                bonusMultiplier: multiplier,
                totalBet: b.Bet.TotalBetCents.InCents,
            });
        });

        this.audio = audio;
        this.resid = resid.Add("BonusMultiplier");
    }

    protected view: PIXI.Container = null;
    public async PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/BonusMultiplier/BonusMultiplierStats/BonusMultiplierStats.json`, ResourceIdentifier.Global.Add("BonusMultiplierStats-json").ScopedResourceName(), true))
        resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/BonusMultiplier/BonusMultiplierStats/BonusMultiplierStats.atlas`, ResourceIdentifier.Global.Add("BonusMultiplierStats-altas").ScopedResourceName(), true))        

        resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/BonusMultiplier/BonusMultiplier.json`, ResourceIdentifier.Global.Add("BonusMultiplier-json").ScopedResourceName(), true))
        resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/BonusMultiplier/BonusMultiplier.atlas`, ResourceIdentifier.Global.Add("BonusMultiplier-altas").ScopedResourceName(), true))        
        this.audio.AddTrack(new Track(`${Settings.ResourcesFolder}multigame/slot/common/resources/tracks/bonusMultiplierShow${Settings.audioFormat}`, this.resid.Add("ShowMultiplier-Track"),true));
        
    }
    protected bonusShowHit: ISkeletonData = null;
    protected bonusShowStats: ISkeletonData = null;
    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        let json = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.Add("BonusMultiplier-json").ScopedResourceName());
        let asset = await PIXI.Assets.load(json.path)
        PIXI.Assets.cache.remove(json.path);
        
        this.bonusShowHit = asset.spineData;

        let json2 = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.Add("BonusMultiplierStats-json").ScopedResourceName());
        let asset2 = await PIXI.Assets.load(json2.path);
        PIXI.Assets.cache.remove(json2.path);

        this.bonusShowStats = asset2.spineData;        
    }

    public View(): PIXI.Container {
        return this.view
    }

    protected bonusMultiplierStatsSpine: Spine = null;
    protected blackAndWhiteFilter = new PIXI.ColorMatrixFilter();
    public Create(pointFillingPotSpineBonusMultiplier : Point) {
        this.view = new PIXI.Container();
        this.view.name = "BonusMultiplierContainer";
        //let yPosition = Settings.Enable2plus1 == true && Settings.Screens == 3 ? Scale.H(1146.5) : Scale.H(1080);        
        this.view.position.set(0, 0 );
        // Create a custom black and white filter

        this.blackAndWhiteFilter.blackAndWhite(true);

        // Apply the filter to the entire container
        //this.view.filters = [this.blackAndWhiteFilter];


        let scale = Settings.Screens == 2 ? 0.20 : 0.30;
        if (Settings.Screens == 3 && Settings.Enable2plus1 == true) scale = 0.20;


        this.bonusMultiplierStatsSpine = CreateSpineResources(this.bonusShowStats, true ,scale);

        if (pointFillingPotSpineBonusMultiplier) {
            this.bonusMultiplierStatsSpine.position.set(Scale.W(pointFillingPotSpineBonusMultiplier?.x), Scale.W(pointFillingPotSpineBonusMultiplier?.y * -1))
        } else {
            let yPosition = Settings.Enable2plus1 == true && Settings.Screens == 3 ? Scale.H(1146.5) : pointFillingPotSpineBonusMultiplier == null ? Scale.H(1080) : Scale.Y(0);
            let xPosition = Settings.Enable2plus1 == true && Settings.Screens == 3 ? Scale.W(0) : pointFillingPotSpineBonusMultiplier == null ? Scale.W(-63.5) : Scale.X(0);
            if (Settings.Screens == 2) {
                yPosition = Scale.Y(76.5);
                xPosition = 0;
                if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidSinShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S) {
                    yPosition = Scale.Y(280.5);
                    xPosition = 0;
                }
            };
            this.bonusMultiplierStatsSpine.position.set(xPosition, yPosition)
        }

        this.bonusMultiplierStatsSpine.name = "Stats";        
        this.view.addChild(this.bonusMultiplierStatsSpine);
        //this.spine.state.setAnimation(0, "idle", true);

        // Add an event listener to the Spine animation           
        this.bonusMultiplierStatsSpine?.state?.addListener({
            //event: this.eventSpine,
            complete: (entry) => {
                this.AnimComplete(entry, this.bonusMultiplierStatsSpine)
            },
            //start: this.StartAnim
        });


        //find Animation LevelStart 
        let animations = this.bonusMultiplierStatsSpine?.spineData?.animations.map(s => s.name);
        this.allLevelAnimationGrouped = this.levels.map(l => ({
            level: l,

            // bonusMultiplierShow: {
            //     animName: animations.filter(a => a.match("winShowBonusX" + l)),
            //     loopAnim: false
            // },

            bonusMultiplierLoop: {
                animName: animations.filter(a => a.match("winBonusX" + l)),
                loopAnim: true
            },

        }));
        //console.log("AnimationBonusMultiplier:", this.allLevelAnimationGrouped);

        this.BonusMultiplierShow();
    }

    protected bonusMultiplierShowSpine: Spine = null;
    protected BonusMultiplierShow() {
        this.bonusMultiplierShowSpine = CreateSpineResources(this.bonusShowHit, true ,0.5);
        this.bonusMultiplierShowSpine.name = "Show";
        this.bonusMultiplierShowSpine?.position.set(Scale.X(503.5), (Settings.ScreenHeight * Settings.Screens ) - (this.bonusMultiplierShowSpine.height + Scale.Y(220)));
        //this.spineShowBonus.autoUpdate = false ;
        this.bonusMultiplierShowSpine.visible = false;
        this.view.addChild(this.bonusMultiplierShowSpine);

        // Add an event listener to the Spine animation           
        this.bonusMultiplierShowSpine?.state?.addListener({
            //event: this.eventSpine,
            complete: (entry) => {
                this.AnimComplete(entry, this.bonusMultiplierShowSpine)
            },
            //start: this.StartAnim
        });
    }

    public Destroy() {

        Safe(() => {
            this.view.destroy({
                children: true
            });
        });

        Safe(() => {
            this.bonusMultiplierShowSpine?.destroy({
                children: true
            });
        })

        Safe(() => {
            this.bonusMultiplierStatsSpine?.destroy({
                children: true
            });
        })
        this.view = null;
        this.bonusMultiplierShowSpine = null;
        this.bonusMultiplierStatsSpine = null;
    }

    protected selecteBet: SlotGameBet = null;
    public SetBet(selectedBet: SlotGameBet , selectedMinBet : boolean = false) {
        const prevBet = this.selecteBet;
        this.selecteBet = selectedBet;

        const newLevelPerBet = this.availableLevelMultiplierPerBet.find(levelPerBet => levelPerBet.totalBet == selectedBet.TotalBetCents.InCents);
        const levelChanged = newLevelPerBet != this.currentLevelPerBet;
        this.currentLevelPerBet = newLevelPerBet;

        //console.log("AllBonusMultiplierBets:", this.availableLevelMultiplierPerBet);
        //console.log("CurrentBonusMultiplierBets:", this.currentLevelPerBet);
        if (!this.allLevelAnimationGrouped?.length) {
            return;
        }

        let bonusMultiplierLevel = this.allLevelAnimationGrouped?.find(l => l.level == this.currentLevelPerBet.bonusMultiplier);
        if (bonusMultiplierLevel == null)
        {
            return;
        }

        // if its first bet selected or level changed, start new animation
        //if (!prevBet || levelChanged || selectedMinBet == true)
        {
            this.PlayAnimationSpine(bonusMultiplierLevel.bonusMultiplierLoop.animName[0], 0, this.bonusMultiplierStatsSpine);
        }
    }

    protected AnimComplete = (trackComplete: ITrackEntry, spine: Spine) => {

        //console.log(`tracksAnims`, this.tracksEnabled);
        if (trackComplete.animation.name.includes("winShowBonusX")) {
            spine?.state?.clearTrack(trackComplete.trackIndex);
            let bonusMultiplierLevel = this.allLevelAnimationGrouped.find(l => l.level == this.currentLevelPerBet.bonusMultiplier);
            this.PlayAnimationSpine(bonusMultiplierLevel.bonusMultiplierLoop.animName[0], 0, spine);
        }
        if (trackComplete.animation.name.includes("winBonusX")) {
            if (spine.name == "Show") {
                spine.visible = false;
                spine?.state?.clearTracks();                
                if (this.debugBonusMulti == false) this.OnShowFinishedCallback?.();
                this.debugBonusMulti == false;                
                this.ResetPoseSpine(spine);
                return
            }
            spine?.state?.clearTrack(trackComplete.trackIndex);
            this.PlayAnimationSpine(trackComplete.animation.name, 0, spine);
        }
    }

    protected StartAnim = (trackComplete: ITrackEntry) => {
        // if (this.tracksEnabled.has(trackComplete.animation.name) == false)
        //     this.tracksEnabled.set(trackComplete.animation.name, {
        //         track: trackComplete.trackIndex, enable: true, loop: false,
        //     });
        //console.log(`trackAnimStart-${trackComplete.animation.name}`, trackComplete);
        //console.log(`tracksAnims`, this.tracksEnabled);       
    }

    protected PlayAnimationSpine(nameAnimation: string, trackAnimationIndex: number, spine: Spine) {
        spine?.state?.addEmptyAnimation(trackAnimationIndex, 0, 0);
        spine?.state?.setEmptyAnimation(trackAnimationIndex, 0);
        //spine?.state?.clearTrack(trackAnimationIndex);
        spine?.state?.setAnimation(trackAnimationIndex, nameAnimation, false);
    }

    protected debugBonusMulti: boolean = false;
    public SetBonusMultiplier(level: number, debugBonusMulti: boolean = false) {
        if (level == this.currentLevelPerBet.bonusMultiplier)
        {
            this.OnShowFinishedCallback?.();
            return;
        }
        
        this.SaveCurrentIncrement(level);
        this.debugBonusMulti = debugBonusMulti;
        let bonusMultiplierLevel = this.allLevelAnimationGrouped.find(l => l.level == level);
        if (bonusMultiplierLevel == null ) return  
        this.currentLevelPerBet.bonusMultiplier = level;      
        // remove filters for reset color 
        //this.view.filters = [];
        this.PlayAnimationSpine(bonusMultiplierLevel.bonusMultiplierLoop.animName[0], 0, this.bonusMultiplierStatsSpine);


        this.bonusMultiplierShowSpine.visible = true;        
        this.audio?.Play(this.resid.ScopedResourceName("ShowMultiplier-Track"));
        this.PlayAnimationSpine(bonusMultiplierLevel.bonusMultiplierLoop.animName[0], 0, this.bonusMultiplierShowSpine);
        
        //console.log("BonusMultiplierWin:", bonusMultiplierLevel);
        //console.log("AUDIO-PLAYING:",this.audio.ListPlaying());

        
    }

    /** save new increment per denom its missing add per pet */
    public SaveCurrentIncrement(level : number) {        
        let currentLevelPerBet = this.availableLevelMultiplierPerBet.find(levelPerBet => levelPerBet.totalBet == this.selecteBet.TotalBetCents.InCents);
        currentLevelPerBet.bonusMultiplier = level;
        this.currentLevelPerBet.bonusMultiplier = level;      
        //console.log(`MultiplierBonus-SaveBetPerLevel-:`,  this.availableLevelMultiplierPerBet);    
        //console.log(`MultiplierBonus-SaveBetPerLevel-:`, currentLevelPerBet);        
    }

    public OnShowFinishedCallback: OnShowFinishedCallback = null;

    protected ResetPoseSpine(spine : Spine){
        spine?.skeleton?.setBonesToSetupPose();
        spine?.skeleton?.setToSetupPose();
        spine?.skeleton?.setSlotsToSetupPose();
        spine?.update(0);
    }

    public ResetLevel(selectedBet: SlotGameBet){
        let currentLevelPerBet = this.availableLevelMultiplierPerBet.find(levelPerBet => levelPerBet.totalBet == selectedBet.TotalBetCents.InCents);
        currentLevelPerBet.bonusMultiplier = 1;
        this.currentLevelPerBet.bonusMultiplier = 1; 
    }

    
}
export class BonusMultiplierShowStats extends BonusMultiplier{

    public override Create() {
        this.view = new PIXI.Container();
        this.view.name = "BonusMultiplierContainer";
        //let yPosition = Settings.Enable2plus1 == true && Settings.Screens == 3 ? Scale.H(1146.5) : Scale.H(1080);
        let yPosition = Settings.Enable2plus1 == true && Settings.Screens == 3 ? Scale.H(903.5) : Scale.H(1359.5);
        let xPosition = Settings.Enable2plus1 == true && Settings.Screens == 3 ? Scale.H(-287.5) : Scale.H(-388.5);
        if (Settings.Screens == 2){ 
            xPosition = Scale.X(-253);
            yPosition = Scale.Y(-181);
            if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidSinShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S) {
                xPosition = Scale.X(-57);
                yPosition = Scale.Y(433.5);
            }
        }
        this.view.position.set(xPosition, yPosition);
        // Create a custom black and white filter

        this.blackAndWhiteFilter.blackAndWhite(true);

        // Apply the filter to the entire container
        //this.view.filters = [this.blackAndWhiteFilter];


        let scale = Settings.Screens == 2 ? 0.5 : 0.8;
        if (Settings.Screens == 3 && Settings.Enable2plus1 == true) scale = 0.5;


        this.bonusMultiplierStatsSpine = CreateSpineResources(this.bonusShowHit, true , scale);
        this.bonusMultiplierStatsSpine.name = "Stats";
        this.view.addChild(this.bonusMultiplierStatsSpine);
        //this.spine.state.setAnimation(0, "idle", true);
        

         //find Animation LevelStart 
         let animations = this.bonusMultiplierStatsSpine?.spineData?.animations.map(s => s.name);
         this.allLevelAnimationGrouped = this.levels.map(l => ({
             level: l,
 
             bonusMultiplierShow: {
                 animName: animations.filter(a => a.match("winShowBonusX" + l)),
                 loopAnim: false
             },
 
             bonusMultiplierLoop: {
                 animName: animations.filter(a => a.match("winBonusX" + l)),
                 loopAnim: true
             },

         }));
        this.view.visible = false;
        //this.PlayAnimationSpine("winBonusX1",0,this.bonusMultiplierStatsSpine);
        let bonusMultiplierLevel = this.allLevelAnimationGrouped.find(l => l.level == this.currentLevel);
        if (this.currentLevel == 1) return
        // Apply the filter to the entire container
        //this.view.filters = [];
        this.view.visible = true;
        this.PlayAnimationSpine(bonusMultiplierLevel.bonusMultiplierLoop.animName[0], 0, this.bonusMultiplierStatsSpine);
    }

    protected override PlayAnimationSpine(nameAnimation: string, trackAnimationIndex: number, spine: Spine) {
        spine?.state?.addEmptyAnimation(trackAnimationIndex, 0, 0);
        spine?.state?.setEmptyAnimation(trackAnimationIndex, 0);
        //spine?.state?.clearTrack(trackAnimationIndex);
        spine?.state?.setAnimation(trackAnimationIndex, nameAnimation, true);
    }

    protected currentLevel : number = 1;
    public SetLevelMultiplier(level: number) {        
        this.currentLevel = level       
    }

    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/BonusMultiplier/BonusStats/WinBonusMultiplierStats.json`, ResourceIdentifier.Global.Add("WinBonusMultiplierStats-json").ScopedResourceName(), true))
        resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/BonusMultiplier/BonusStats/WinBonusMultiplierStats.atlas`, ResourceIdentifier.Global.Add("WinBonusMultiplierStats-altas").ScopedResourceName(), true))        
    }

    
    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        let json = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.Add("WinBonusMultiplierStats-json").ScopedResourceName());
        let asset = await PIXI.Assets.load(json.path);
        this.bonusShowHit = asset.spineData;
    }
    
    public SetScale(scaleX : number , scaleY : number){
        this.bonusMultiplierStatsSpine.scale.set(Scale.X(scaleX),Scale.Y(scaleY));
    }

    public Hide(){
        this.bonusMultiplierStatsSpine.visible = false;
    }
}


export type OnShowFinishedCallback = () => void;

export class BonusMultiplierResponsive extends BonusMultiplier{
    public override Create(pointFillingPotSpineBonusMultiplier : Point): void {
        super.Create(pointFillingPotSpineBonusMultiplier);
    }

    protected override BonusMultiplierShow() {
            this.bonusMultiplierShowSpine = CreateSpineResources(this.bonusShowHit, true , 0.5);
            this.bonusMultiplierShowSpine.name = "Show";
            this.bonusMultiplierShowSpine.pivot.set(this.bonusMultiplierShowSpine.width / 2, this.bonusMultiplierShowSpine.height / 2);
            //this.bonusMultiplierShowSpine.position.set(Scale.W(1920) / 4 + Scale.H(210), Scale.H(1080) / 4 - Scale.H(20)); 
            //this.spineShowBonus.autoUpdate = false ;
            this.bonusMultiplierShowSpine.visible = false;
            this.view.addChild(this.bonusMultiplierShowSpine);
            
    
            // Add an event listener to the Spine animation           
            this.bonusMultiplierShowSpine?.state?.addListener({
                //event: this.eventSpine,
                complete: (entry) => {
                    this.AnimComplete(entry, this.bonusMultiplierShowSpine)
                },
                //start: this.StartAnim
            });

    }


    public override View(): PIXI.Container {
        return this.view;
    }

    // public OnResize(){
    //     //Set to initial position
    //     this.bonusMultiplierStatsSpine.position.set(0,0);
    //     this.bonusMultiplierStatsSpine.scale.set(1);

    //     //Set position based on orientation
    //     if (GetOrientation() == Orientation.Portrait)
    //     {
    //         this.bonusMultiplierStatsSpine.position.y = -Scale.Y(500);
    //         return;
    //     }

    //     this.bonusMultiplierStatsSpine.position.x = - Scale.X(250);
    //     this.bonusMultiplierStatsSpine.scale.set(0.2);

    // }
}

export class BonusMultiplierStatsResponsive extends BonusMultiplierShowStats {
    public override Create(): void {
        this.view = new PIXI.Container();
        this.view.name = "BonusMultiplierContainerResponsive";
 
        this.blackAndWhiteFilter.blackAndWhite(true);

        // Apply the filter to the entire container
        //this.view.filters = [this.blackAndWhiteFilter];


        this.bonusMultiplierStatsSpine = CreateSpineResources(this.bonusShowHit);
        this.bonusMultiplierStatsSpine.name = "Stats";
        
        this.view.addChild(this.bonusMultiplierStatsSpine);

        //this.spine.state.setAnimation(0, "idle", true);
        

         //find Animation LevelStart 
         let animations = this.bonusMultiplierStatsSpine?.spineData?.animations.map(s => s.name);
         this.allLevelAnimationGrouped = this.levels.map(l => ({
             level: l,
 
             bonusMultiplierShow: {
                 animName: animations.filter(a => a.match("winShowBonusX" + l)),
                 loopAnim: false
             },
 
             bonusMultiplierLoop: {
                 animName: animations.filter(a => a.match("winBonusX" + l)),
                 loopAnim: true
             },

         }));
        this.view.visible = false;
        //this.PlayAnimationSpine("winBonusX1",0,this.bonusMultiplierStatsSpine);
        let bonusMultiplierLevel = this.allLevelAnimationGrouped.find(l => l.level == this.currentLevel);
        if (this.currentLevel == 1) return
        // Apply the filter to the entire container
        //this.view.filters = [];
        this.view.visible = true;
        this.PlayAnimationSpine(bonusMultiplierLevel.bonusMultiplierLoop.animName[0], 0, this.bonusMultiplierStatsSpine);
        
    }

    public override SetScale(scaleX: number, scaleY: number): void {
        this.bonusMultiplierStatsSpine.scale.set(scaleX, scaleY);
        (window as any).multiplier = this.bonusMultiplierStatsSpine; 

    }

    public getSkeleton() : Spine {
        return this.bonusMultiplierStatsSpine;
    }

}

